import "core-js/modules/es.object.keys.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "page-login"
  }, [_c("img", {
    staticClass: "page-login-bg",
    attrs: {
      src: "https://oss-mng.rich-link.cn/undefined/20260803/1785723948431.png",
      alt: ""
    }
  }), _c("div", {
    staticClass: "content"
  }, [_c("div", {
    staticClass: "top"
  }, [_c("router-link", {
    staticClass: "header",
    staticStyle: {
      left: "auto",
      right: "20px"
    },
    attrs: {
      to: "/index"
    }
  }, [_c("img", {
    staticClass: "icon",
    attrs: {
      src: require("./image/workshop/logo.png"),
      alt: ""
    }
  }), _c("div", [_vm._v("智慧渔业管控平台")])])], 1), _c("div", {
    staticClass: "center"
  }, [_c("div", {
    staticClass: "item video-item"
  }, [_vm._m(0), _c("div", {
    staticClass: "item-content"
  }, [_vm.detail.showVideoId ? _c("m3u8Video", {
    attrs: {
      id: _vm.detail.showVideoId
    }
  }) : _vm._e()], 1)]), _vm._l(_vm.list, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "item"
    }, [_c("div", {
      staticClass: "title"
    }, [_c("img", {
      attrs: {
        src: "https://oss-mng.rich-link.cn/undefined/20260813/1786599904139.png",
        alt: ""
      }
    }), _c("div", [_vm._v("一期" + _vm._s(index + 1) + "号池")])]), _c("div", {
      staticClass: "item-content"
    }, [_c("div", {
      staticClass: "img"
    }, [_c("img", {
      attrs: {
        src: "https://oss-mng.rich-link.cn/undefined/20260813/1786601659735.png",
        alt: ""
      }
    }), _c("div", {
      staticClass: "btn",
      on: {
        click: function click($event) {
          _vm.cmdClick(item, JSON.parse(item.items[0].valueEnums)[item.items[0].value]);
        }
      }
    }, [JSON.parse(item.items[0].valueEnums)[item.items[0].value] === "停止" ? _c("img", {
      attrs: {
        src: "https://oss-mng.rich-link.cn/undefined/20260813/1786601696942.png",
        alt: ""
      }
    }) : _c("img", {
      attrs: {
        src: "https://oss-mng.rich-link.cn/undefined/20260813/1786601994268.png",
        alt: ""
      }
    }), _c("div", [_vm._v(_vm._s(JSON.parse(item.items[0].valueEnums)[item.items[0].value] === "停止" ? "启动" : "停止"))])])]), _c("div", {
      staticClass: "info"
    }, _vm._l(item.items, function (opt, idx) {
      return _c("div", {
        key: opt.id,
        staticClass: "info-item"
      }, [_c("div", {
        staticClass: "name"
      }, [_c("div", {
        staticClass: "dot"
      }), _c("div", [_vm._v(_vm._s(opt.typeName.split("：")[1]))])]), idx == 2 && _vm.isAerationRunning(index) ? _c("div", {
        staticClass: "value"
      }, [_vm._v(" " + _vm._s(_vm.getWaveValue(index)) + " "), _c("span", [_vm._v(_vm._s(opt.unit || ""))])]) : _c("div", {
        staticClass: "value",
        class: {
          red: JSON.parse(opt.valueEnums)[opt.value] === "停止" || JSON.parse(opt.valueEnums)[opt.value] === "报警",
          green: JSON.parse(opt.valueEnums)[opt.value] === "启动" || JSON.parse(opt.valueEnums)[opt.value] === "正常"
        }
      }, [_vm._v(" " + _vm._s(JSON.parse(opt.valueEnums)[opt.value] ? JSON.parse(opt.valueEnums)[opt.value] : opt.value) + " "), _c("span", [_vm._v(_vm._s(opt.unit || ""))])])]);
    }), 0)])]);
  })], 2)])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title"
  }, [_c("img", {
    attrs: {
      src: "https://oss-mng.rich-link.cn/undefined/20260813/1786599904139.png",
      alt: ""
    }
  }), _c("div", [_vm._v("视频监控")])]);
}];
render._withStripped = true;
export { render, staticRenderFns };